<div class="flex flex-column align-items-start gap-3 align-self-stretch pb-4 pt-4">
  <fieldset class="sps-fieldset form-data-container separator">
    <div class="w-full">
      <div class="flex align-items-end gap-3 align-self-stretch">
        <div class="flex flex-column gap-2 flex-1 align-items-start">
          <label for="link">{{ i18n.i18nLng()['LINK'] }}</label>
          <input pInputText id="link" fluid [(ngModel)]="paymentPageLinkData.link" [disabled]="true" pSize="large"/>
        </div>
        <p-button icon="pi pi-copy"
                  [text]="true"
                  severity="contrast"
                  [pTooltip]="i18n.i18nLng()['COPYLINKCLIPBOARD']"
                  [attr.aria-label]="i18n.i18nLng()['COPYLINKCLIPBOARD']"
                  (click)="copyToClipboard(paymentPageLinkData.link)"/>
      </div>
    </div>
  </fieldset>

  <fieldset class="sps-fieldset form-data-container separator">
    <div class="flex flex-column pb-2">
      <legend class="p-dialog-title">{{ i18n.i18nLng()['BUTTONHTMLCODETITLE'] }}</legend>
    </div>
    <div  class="flex align-items-start gap-3 align-self-stretch">
      <div class="flex flex-1 p-2 gap-1 align-self-stretch align-items-start html-code-container">
        <div class="flex p-2 flex-column align-items-start gap-2 flex-1 line-height-3 html-text">
          {{ paymentPageLinkData.buttonHtmlCode }}
        </div>
        <div class="flex align-items-center">
          <p-button icon="pi pi-copy"
                    [text]="true"
                    severity="contrast"
                    [pTooltip]="i18n.i18nLng()['COPYBUTTONHTMLCLIPBOARD']"
                    [attr.aria-label]="i18n.i18nLng()['COPYBUTTONHTMLCLIPBOARD']"
                    (click)="copyToClipboard(paymentPageLinkData.buttonHtmlCode)"/>
        </div>
      </div>
      <div class="flex p-3 gap-3 justify-content-center align-items-center qrcode-container">
        <!--
        <qr-code [value]="paymentPageLinkData.link"
                 size="200"
                 [margin]="0"
                 errorCorrectionLevel="M"
                 [attr.aria-label]="i18n.i18nLng()['LINKQRCODE']">
        </qr-code>
        -->
        <img [src]="'data:image/png;base64,' + paymentPageLinkData.qrCode" alt="QR Code" width="200" height="200" aria-label="QR Code">
      </div>
    </div>
  </fieldset>
</div>
